/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1207
 */

module.exports = {
  wrapper: "SignInDialog_wrapper__1fvNG",
  ready: "SignInDialog_ready__3LSnR"
}
